import { useCallback } from "react";
import { useGenerateManagementReport } from "../services/reportService";

/**
 * Encapsulates the management report PDF generation.
 * Converts the boolean includeYearSummary to API format (0 | 1).
 */
export function useManagementReportHandler() {
  const generateManagementReport = useGenerateManagementReport();

  return useCallback(
    async (
      start_date: string,
      end_date: string,
      building_id: string,
      includeYearSummary: boolean
    ): Promise<Blob | null> => {
      const blob = await generateManagementReport.mutateAsync({
        start_date,
        end_date,
        building_id,
        year_summary: includeYearSummary ? 1 : 0,
      });
      return blob;
    },
    [generateManagementReport]
  );
}
